import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

function cx(...inputs: any[]) {
  return twMerge(clsx(inputs))
}

export default cx
